
import { Component, Prop, Vue } from 'vue-property-decorator'
import InputTextBase from '@/components/atoms/InputTextBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

/**
 * テキスト検索入力欄
 */
@Component({
  components: {
    InputTextBase,
    ImageBase,
    ButtonBase,
  },
})
export default class TextSearch extends Vue {
  /** 未入力時の説明文 */
  @Prop()
  private placeholder?: string

  /** 検索ボタン押下時の処理 */
  @Prop()
  private eventClickSearch!: () => void

  /** 入力テキスト */
  public text = ''

  /**
   * 検索文字列を設定
   *
   * @param value 文字列
   */
  public setText(value: string): void {
    this.text = value
  }
}
